import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=2a74f77c&scoped=true&"
import script from "./addStock.vue?vue&type=script&lang=js&"
export * from "./addStock.vue?vue&type=script&lang=js&"
import style0 from "./addStock.vue?vue&type=style&index=0&id=2a74f77c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a74f77c",
  null
  
)

export default component.exports